export const PRODUCT_NAME = "SAT-014";

export const AES_KEY = "aesKey";
export const TOKEN_STORAGE_KEY = "tokens";

export const ROOT_PATH = "";
export const LOGIN_PATH = "/";
export const HOME_PATH = "/home";
export const ADMIN_HOME_PATH = "/admin/home";
export const DASHBOARD_PATH = "/home";
export const ADMIN_DASHBOARD_PATH = "/admin/home";
export const CHANGE_PASSWORD_PATH = "/home/password-change";
export const ADMIN_CHANGE_PASSWORD_PATH = "/admin/home/password-change";

export const FETCH_API_CLIENT_ENCRYPT_URL_STR = "s";

export enum PasswordChangeType {
  INITIAL = "initial",
  EXPIRED = "expired",
}
